export const RECENT_IMPERSONATED_USERS_KEY = 'plm-recent-impersonated-users'
export const IS_IMPERSONATING_KEY = 'plm-is-impersonating'
export const MAX_RECENT_IMPERSONATED_USERS = 5

export const canShowImpersonationAction = ({
  isInternal,
  canImpersonate,
  isImpersonating,
}: {
  isInternal: boolean
  canImpersonate: boolean
  isImpersonating: boolean
}) => isInternal && canImpersonate && !isImpersonating

export type RecentImpersonatedUser = {
  userProfileId: string
  firstName: string
  lastName: string
  companyName: string
  email: string
}

const isRecentUser = (value: unknown): value is RecentImpersonatedUser => {
  if (!value || typeof value !== 'object') return false
  const user = value as Partial<RecentImpersonatedUser>
  return (
    typeof user.userProfileId === 'string' &&
    typeof user.firstName === 'string' &&
    typeof user.lastName === 'string' &&
    typeof user.companyName === 'string' &&
    typeof user.email === 'string'
  )
}

export const getRecentImpersonatedUsers = (): RecentImpersonatedUser[] => {
  try {
    const stored = localStorage.getItem(RECENT_IMPERSONATED_USERS_KEY)
    if (!stored) return []
    const parsed: unknown = JSON.parse(stored)
    if (!Array.isArray(parsed)) return []
    return parsed.filter(isRecentUser).slice(0, MAX_RECENT_IMPERSONATED_USERS)
  } catch {
    return []
  }
}

export const saveRecentImpersonatedUser = (
  user: RecentImpersonatedUser,
): RecentImpersonatedUser[] => {
  const updated = getRecentImpersonatedUsers().filter(
    (recent) => recent.userProfileId !== user.userProfileId,
  )
  if (updated.length >= MAX_RECENT_IMPERSONATED_USERS) {
    updated.pop()
  }
  updated.unshift(user)

  try {
    localStorage.setItem(RECENT_IMPERSONATED_USERS_KEY, JSON.stringify(updated))
  } catch {
    // Browser storage may be disabled or full; impersonation can still proceed.
  }
  return updated
}
